import PlaceIcon from '@mui/icons-material/Place';
import { PlacesList } from './PlacesList';
import { PlacesCreate } from './PlacesCreate';
import { PlacesEdit } from './PlacesEdit';

const places = {
  list: PlacesList,
  create: PlacesCreate,
  edit: PlacesEdit,
  icon: PlaceIcon,
};

export default places;
